import { BREAKPOINTS } from 'javascripts/constants';
import MasonryLayout from 'masonry-layout';

export default class SpeakerGroup {
  constructor($speakerGroup, options = {}) {
    this.options = {
      ...options,
    };

    this.$speakerGroup = $speakerGroup;
    this.$itemsContainer = this.$speakerGroup.querySelector('.speaker-group__items');
    this.mql = window.matchMedia(`(min-width: ${BREAKPOINTS.l})`);

    this.bindedMql = this.onMediaQueryChange.bind(this);

    // Listen on media query changes
    this.mql.addEventListener('change', this.bindedMql);

    if (this.mql.matches) {
      this.init();
    } else {
      this.deInit();
    }
  }

  init() {
    const $groupItems = this.$speakerGroup.querySelector('.speaker-group__items');
    this.masonryLayout = new MasonryLayout($groupItems, {
      itemSelector: '.speaker-group__item',
      gutter: 0,
    });
  }

  deInit() {
    if (this.masonryLayout) {
      this.masonryLayout.destroy();
    }
  }

  onMediaQueryChange() {
    if (this.mql.matches) {
      this.init();
    } else {
      this.deInit();
    }
  }
}

document.querySelectorAll('.js-speaker-group').forEach(
  $speakerGroup => new SpeakerGroup($speakerGroup),
);
